module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-news"
  }, [_c('content-item', {
    attrs: {
      "title": _vm.$t('news')
    }
  }, [_c('div', {
    staticClass: "news-list"
  }, _vm._l((_vm.curNews), function(news, index) {
    return _c('div', {
      staticClass: "news-item"
    }, [_c('div', {
      staticClass: "logo"
    }, [_c('div', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy:background-image",
        value: (news.pic_url),
        expression: " news.pic_url",
        arg: "background-image"
      }],
      staticClass: "logo-img"
    })]), _vm._v(" "), _c('router-link', {
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "to": '/news/' + news.id
      }
    }, [_c('div', {
      staticClass: "desc"
    }, [_c('div', {
      staticClass: "desc-header"
    }, [_c('p', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(news.title))])]), _vm._v(" "), _c('div', {
      staticClass: "post-date"
    }, [_vm._v("\n                            " + _vm._s(news.news_date) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "desc-content"
    }, [_c('p', [_vm._v(_vm._s(news.tips))])])])])], 1)
  })), _vm._v(" "), (_vm.all > 1) ? _c('div', {
    staticClass: "news-pager"
  }, [(_vm.cur > 1) ? _c('div', {
    staticClass: "pager pager-text",
    on: {
      "click": function($event) {
        _vm.cur--;
        _vm.getNews(_vm.cur)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('prevPage')))]) : _vm._e(), _vm._v(" "), (_vm.cur == 1) ? _c('div', {
    staticClass: "pager pager-text not-allowed"
  }, [_vm._v(_vm._s(_vm.$t('prevPage')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.indexs), function(index) {
    return _c('div', {
      staticClass: "pager pager-number",
      class: {
        'active': _vm.cur == index
      },
      on: {
        "click": function($event) {
          _vm.btnClick(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(index) + "\n            ")])
  }), _vm._v(" "), (_vm.cur < _vm.all) ? _c('div', {
    staticClass: "pager pager-text",
    on: {
      "click": function($event) {
        _vm.cur++;
        _vm.getNews(_vm.cur)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('nextPage')))]) : _vm._e(), _vm._v(" "), (_vm.cur == _vm.all) ? _c('div', {
    staticClass: "pager pager-text  not-allowed"
  }, [_vm._v(_vm._s(_vm.$t('nextPage')))]) : _vm._e()], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6bbe0990!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/News.vue
// module id = 384
// module chunks = 7